<template>
  <div class="LmActorSelect mb-8">
    <div :class="{'flex items-center': hasSlot}">
      <span
        v-if="hasSlot"
        class="mr-3 flex-shrink-0 font-mono text-xxs text-gray-500 tracking-wider uppercase"
      >
        <slot />
      </span>
      <select
        v-model="data"
        class="w-full text-xs font-mono"
        :class="selectedActorColor"
        @change="onChange"
      >
        <option :value="null" disabled hidden>[Select Actor] </option>
        <option
          v-for="option in actorOptions"
          :key="option._id"
          :value="option._id"
          class="font-mono text-xs"
          :class="'text-' + option.color"
          :disabled="option.disabled"
          v-html="option.name"
        />
      </select>
    </div>
    <span
      v-if="error"
      class="block w-full flex items-center mt-1 pt-1 text-error text-xs border-t border-error"
    >
      Please choose an Actor
    </span>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'LmActorSelect',
  props: {
    selectedActor: {
      type: Object,
      default: null
    },
    showPlaceholder: {
      type: Boolean,
      default: false
    },
    checkRights: {
      type: Boolean,
      default: false
    },
    allowRoot: {
      type: Boolean,
      default: false
    },
    disableChildren: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: null, // ActorId
      editActorId: '',
      error: false,
      actorOptions: []
    }
  },
  computed: {
    ...mapGetters([
      'currentLandscape',
      'hasManagerRightsActor',
      'getActorByID'
    ]),
    hasSlot() {
      return !!this.$slots.default
    },
    selectedActorColor() {
      return this.data
        ? this.data === this.currentLandscape._id
          ? 'text-gray-900'
          : 'text-' + this.getActorByID(this.data).color
        : 'text-gray-500'
    }
  },
  watch: {
    selectedActor() {
      this.updateActor()
    },
    currentLandscape() {
      this.buildTree()
    }
  },
  mounted() {
    this.buildTree()
    if (this.selectedActor) {
      this.updateActor()
    }
  },
  methods: {
    updateActor() {
      if (!this.showPlaceholder) {
        this.data = this.selectedActor ? this.selectedActor._id : null
        this.editActorId = this.data
      }
    },
    buildOptionsArray(actor, depth, disableFlag = false, prefix = '') {
      const root = depth === 0
      if (!root && this.disableChildren) {
        disableFlag = disableFlag || actor._id === this.selectedActor._id
      }
      this.actorOptions.push({
        _id: root ? this.currentLandscape._id : actor._id,
        name: root
          ? this.currentLandscape.name.toUpperCase()
          : prefix + actor.name,
        color: root ? 'gray-900' : actor.color,
        disabled:
          disableFlag ||
          (root && !this.allowRoot) ||
          (!root && this.checkRights && !this.hasManagerRightsActor(actor))
      })
      for (let child of actor.actors) {
        this.buildOptionsArray(child, depth + 1, disableFlag, prefix + '&nbsp;')
      }
    },
    buildTree() {
      this.actorOptions = []
      this.buildOptionsArray(this.currentLandscape, 0)
    },
    validateData() {
      this.error = false
      if (this.data) return true
      this.error = true
      return false
    },
    onChange() {
      this.clearErrors()
      this.$emit('on-select', this.data)
    },
    clearErrors() {
      this.error = false
    },
    reset() {
      this.data = this.editActorId
      this.clearErrors()
    }
  }
}
</script>

<style>
.LmActorSelect option:disabled {
  background: theme('colors.gray.200');
  color: theme('colors.gray.300');
}
.js-focus-visible .LmActorSelect select:focus:not(.focus-visible) {
  outline: none;
}
</style>
